import _objectWithoutProperties from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["theme"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { COMMON, LAYOUT, get } from '../constants';
import defaultTheme from '../theme';
import sx from '../sx';
import { XIcon } from '@primer/octicons-react';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
var StyledButton = styled.button.withConfig({
  displayName: "ButtonClose__StyledButton",
  componentId: "sc-13mzqph-0"
})(["border:none;padding:0;background:transparent;outline:none;cursor:pointer;border-radius:", ";&:focus{box-shadow:", ";}&:active{color:", ";}", ";", ";", ";"], get('radii.2'), get('buttons.close.shadow.focus'), get('buttons.close.color.default'), COMMON, LAYOUT, sx);
var ButtonClose = forwardRef(function (_ref, ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? defaultTheme : _ref$theme,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    ref: ref,
    "aria-label": "Close",
    theme: theme
  }, props), /*#__PURE__*/React.createElement(XIcon, null));
});
export default ButtonClose;